import fetch from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import { convertChartData, filterWithClassesAndTransformChartData, generateUpdatedArrayWithMappedDivisions, getUniqueDivisions } from '../../utils/fieldboxKpiDataGenerator';
import store from '../store';
import { enqueueSnackbar } from './snackbar';

export const listDbwVsTarget = () => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.DBW_VS_TARGET_LIST_LOADING,
  });
  return fetch
    .post('enverus/DbwTarget')
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(async (data) => {
      const { startDate, endDate } = data[0];
      dispatch({
        type: REDUX_ACTIONS.DBW_VS_TARGET_SET_DATE,
        payload: {
          selectedStartDateTime: startDate,
          selectedEndDateTime: endDate
        }
      });

      dispatch({
        type: REDUX_ACTIONS.DBW_VS_TARGET_LIST_SUCCESS,
        payload: {
          data,
          paginatedElements: data.length,
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.DBW_VS_TARGET_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};

export const syncDbwVsTarget = ({ startDate, endDate }) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.DBW_SYNC_LOADING,
    payload: 'Generating Report.. Please wait'
  });

  dispatch({
    type: REDUX_ACTIONS.DBW_VS_TARGET_LIST_LOADING,
  });

  dispatch({
    type: REDUX_ACTIONS.DBW_VS_TARGET_DIVISION_RESET
  });
  dispatch({
    type: REDUX_ACTIONS.CHECKINS_RESET
  });
  const body = {
    input: {
      startDate,
      endDate
    }
  };
  return fetch
    .post('enverus/syncDbwTarget', body)
    .then((resp) => {
      if (!resp.ok) {
        return Promise.reject(resp);
      }
      return resp.json();
    })
    .then(async(res) => {
      dispatch({
        type: REDUX_ACTIONS.DBW_SYNC_LOADING,
        payload: 'Report complete'
      });
      await dispatch(
        enqueueSnackbar(
          res.message || 'Sync Successfully Completed',
          'success',
          new Date().getTime() + Math.random()
        )
      );
      await dispatch(listDbwVsTarget());
    })
    .catch(async (error) => {
      dispatch({
        type: REDUX_ACTIONS.DBW_SYNC_LOADING,
        payload: error.message || 'Error syncing on DbwVsTarget'
      });
      dispatch(
        enqueueSnackbar(
          error.message || 'Error syncing on DbwVsTarget',
          'error',
          new Date().getTime() + Math.random()
        )
      );
    });
};

export const fetchDbwVsTargetDetail = (body) => (dispatch) => {
  return fetch
    .post('enverus/DbwTargetDtls', { input: body })
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.DBW_VS_TARGET_FETCH_DETAILS_SUCCESS,
        payload: data,
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.DBW_VS_TARGET_FETCH_DETAILS_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};

export const updateMarketshareKPIs = (data) => (dispatch) => {
  const updatedData = generateUpdatedArrayWithMappedDivisions(data);
  dispatch({
    type: REDUX_ACTIONS.MARKETSHARE_KPIS_LIST_LOADING,
  });
  const { startDate, endDate } = data[0];
  dispatch({
    type: REDUX_ACTIONS.DBW_VS_TARGET_SET_DATE,
    payload: {
      selectedStartDateTime: startDate,
      selectedEndDateTime: endDate
    }
  });

  dispatch({
    type: REDUX_ACTIONS.MARKETSHARE_KPIS_LIST_SUCCESS,
    payload: {
      data: updatedData,
      paginatedElements: updatedData.length,
      chartData: convertChartData(updatedData),
      divisions: getUniqueDivisions(updatedData)
    },
  });

  localStorage.removeItem('marketshare'); // cleanup to call api again on refresh
};

export const getMarketshareKPIs = () => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.MARKETSHARE_KPIS_LIST_LOADING,
  });

  return fetch
    .post('enverus/DbwTarget')
    .then((resp) => {
      if (!resp.ok) {
        return Promise.reject(resp);
      }
      return resp.json();
    })
    .then((data) => {
      const { startDate, endDate } = data[0];
      dispatch({
        type: REDUX_ACTIONS.DBW_VS_TARGET_SET_DATE,
        payload: {
          selectedStartDateTime: startDate,
          selectedEndDateTime: endDate
        }
      });
      const updatedData = generateUpdatedArrayWithMappedDivisions(data);

      dispatch({
        type: REDUX_ACTIONS.MARKETSHARE_KPIS_LIST_SUCCESS,
        payload: {
          data: updatedData,
          paginatedElements: updatedData.length,
          chartData: convertChartData(updatedData),
          divisions: getUniqueDivisions(updatedData)
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);

      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.MARKETSHARE_KPIS_LIST_ERROR,
        payload: { ...error, message: errorMessage },
      });
    });
};

export const setSelectedDivisionClass = (division, classes, searchTerm) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.MARKETSHARE_KPIS_LIST_LOADING,
  });

  const initialData = store.getState().dbwVsTarget.kpis.initialData;

  const { data, chartData } = filterWithClassesAndTransformChartData(initialData, division, classes, searchTerm);

  dispatch({
    type: REDUX_ACTIONS.MARKETSHARE_KPIS_SET_DIVISION,
    payload: {
      selectedDivision: division,
      selectedClasses: classes,
      data,
      chartData,
      searchTerm
    },
  });
};
